import axios from 'axios'
import store from './store'
import router from './router'

axios.interceptors.request.use(config => {
  store.state.isLoading = true
  return config
}, err => {
  return Promise.reject(err)
})

var errorTimes = 0 // 計算401次數

axios.interceptors.response.use(response => {
  store.state.isLoading = false
  return response
}, error => {
  if (error.response) {
    store.state.isLoading = false
    switch (error.response.status) {
      case 401:
        if (!errorTimes) {
          errorTimes++
          alert('You have been logged out because your session has expired.')
          router.push('/login')
        }
        break
      // case 404:
      //   router.push('/notfound')
      //   break
    }
  }
  return Promise.reject(error.response)
})
export default axios
